import React, { useCallback } from 'react'
import { InputAdornment, Slider, TextField, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { SliderThumb } from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { useEffect, useRef } from 'react';
import { FlashAutoRounded } from '@mui/icons-material';

const AirbnbSlider = styled(Slider)(({ theme }) => ({
  color: '#ff6614',
  height: 3,
  padding: '13px 0',
  '& .MuiSlider-thumb': {
    height: 27,
    width: 27,
    backgroundColor: '#fff',
    border: '1px solid currentColor',
    '&:hover': {
      boxShadow: '0 0 0 8px rgba(58, 133, 137, 0.16)',
    },
    '& .airbnb-bar': {
      height: 9,
      width: 1,
      backgroundColor: 'currentColor',
      marginLeft: 1,
      marginRight: 1,
    },
  },
  '& .MuiSlider-track': {
    height: 3,
  },
  '& .MuiSlider-rail': {
    color: theme.palette.mode === 'dark' ? '#bfbfbf' : '#d8d8d8',
    opacity: theme.palette.mode === 'dark' ? undefined : 1,
    height: 3,
  },
}));

function AirbnbThumbComponent(props) {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
      <span className="airbnb-bar" />
    </SliderThumb>
  );
}

AirbnbThumbComponent.propTypes = {
  children: PropTypes.node,
};

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  if (!ref.current) { ref.current = value }
  return ref.current;
}


function DisplayTypeCompanentPriceMoby(props) {
  const inputStart = useRef(null);
  const inputEnd = useRef(null);
  let goPriceStep = 99;
  let priceDiapazon = 5000;
  let minValuePrice = Number(props.propertyValuePriceMaxMin[0]);
  let maxValuePrice = Number(props.propertyValuePriceMaxMin[1]);
  let minValuePriceProp = Number(props.propertyValuePrice[0] == null ? minValuePrice : props.propertyValuePrice[0] );
  let maxValuePriceProp = Number(props.propertyValuePrice[1]);
  const [getchecked, setGetChecked] = React.useState(false);
  const [checked, setChecked] = React.useState(props.checked);
  const [valuemin, setValueMin] = React.useState(minValuePriceProp);
  const [valuemax, setValueMax] = React.useState(maxValuePriceProp);
  

  const prevChecked = usePrevious(checked);
  const prevValuemin = usePrevious(valuemin);
  const prevValuemax = usePrevious(valuemax);
  const prevGetChecked = usePrevious(getchecked);

  if (!props.propertyValuePriceMaxMin[0]) { setValueMin(1); }
  if (!props.propertyValuePriceMaxMin[1]) { setValueMax(42000); }

  const handleChange = (event, newValue) => {

    if (maxValuePrice > priceDiapazon) {

     // var minval = Math.round(newValue[0] < 0.7 * maxValuePrice ? priceDiapazon * (newValue[0] / (0.7 * maxValuePrice)) : priceDiapazon + ((newValue[0] - 0.7 * maxValuePrice) * (maxValuePrice - priceDiapazon) / (0.3 * maxValuePrice)));

      // var maxval = Math.round(newValue[1] < 0.7*maxValuePrice ? newValue[1] / 3.5 : 0.7*maxValuePrice/3.5 + ((newValue[1] - 0.7*maxValuePrice)*(80/30)));

     // var maxval = Math.round(newValue[1] < 0.7 * maxValuePrice ? priceDiapazon * (newValue[1] / (0.7 * maxValuePrice)) : priceDiapazon + ((newValue[1] - 0.7 * maxValuePrice) * (maxValuePrice - priceDiapazon) / (0.3 * maxValuePrice)));
      var minval = Math.round(newValue[0]);
      var maxval = Math.round(newValue[1]);
    } else {

      var minval = Math.round(newValue[0]);
      var maxval = Math.round(newValue[1]);

      //var maxval = Math.round(newValue[1] < 0.7*maxValuePrice ? newValue[1] / 3.5 : 0.7*maxValuePrice/3.5 + ((newValue[1] - 0.7*maxValuePrice)*(80/30)));



    }
    if (minval < minValuePrice) { minval = minValuePrice; }

    if (maxval > maxValuePrice) { maxval = maxValuePrice; }

    setValueMin(minval);
    setValueMax(maxval);

    setGetChecked(false);
  };

  const showMouseUp = () => {

    checked[props.code] = [String(valuemin),String(valuemax)];
    setChecked(checked);
    props.setCheckenFiltr(checked);
    setGetChecked(true);
  };


  useEffect(() => {

    if (getchecked == true) {

      console.log("старое useEffect", prevChecked);
      console.log("новое useEffect", checked);
      console.log("запуск", getchecked, [valuemin, valuemax]);
        props.submitForm();

    }
  }, [getchecked])

  let closeSlide = () => {
    setGetChecked(false);
  }

  const handleChangestart = (event) => {
    let prevDefoltValue = Number(inputStart.current);
    let val = Number(event.target.value);
    let valMinus = val - goPriceStep;
    let valPlus = val + goPriceStep;

    let rezClickVal = val - prevDefoltValue;
    let absVal = Math.abs(rezClickVal);

    if (val <= maxValuePrice && val >= minValuePrice) {
      if (absVal < goPriceStep + 3) {
        if (rezClickVal > 0) {
          setValueMin(String(valPlus));
        }
        if (rezClickVal < 0) {
          setValueMin(String(valMinus));
        }

      } else {
        setValueMin(String(val));
      }
    }

  };

  const onKeyDownstart = (event) => {
    setValueMin(Number(event.target.value));
  }

  const handleChangeend = (event) => {
    let prevDefoltValue = Number(inputEnd.current);
    let val = Number(event.target.value);
    let valMinus = val - goPriceStep;
    let valPlus = val + goPriceStep;

    let rezClickVal = val - prevDefoltValue;
    let absVal = Math.abs(rezClickVal);

    if (val <= maxValuePrice && val >= minValuePrice) {
      if (absVal < 102) {
        if (rezClickVal > 0) {
          setValueMax(valPlus);
        }
        if (rezClickVal < 0) {
          setValueMax(valMinus);
        }

      } else {
        setValueMax(val);
      }
    }
  };


  const onKeyDownEnd = (event) => {
    setValueMax(Number(event.target.value));
  }


  useEffect(() => {
    inputStart.current = valuemin;
  }, [valuemin]);

  useEffect(() => {
    inputEnd.current = valuemax;
  }, [valuemax]);

  return (
    <>
      <Typography sx={{ mt: 1, mb: 1, fontWeight: 400 }} variant="h7" component="div">
        {props.name},{"руб"}
      </Typography>

      <Box sx={{ width: '100%',ml: 3 }}>
        <Stack
          direction="row"
          divider={<Divider orientation="horizontal" flexItem />}
          spacing={2}
        >
          <TextField
            ref={inputStart}
            min={props.propertyValuePrice[0]}
            label="от"
            onChange={handleChangestart}
            onKeyDown={onKeyDownstart}
            value={valuemin}
            type="number"
            id="outlined-start-adornment"
            sx={{ m: 0, width: '15ch', backgroundColor: "#ffffff" }}
            InputProps={{
              startAdornment: <InputAdornment position="start"></InputAdornment>,
            }}
          />
          <TextField
            ref={inputEnd}
            type="number"
            max={props.propertyValuePrice[1]}
            value={valuemax}
            onChange={handleChangeend}
            onKeyDown={onKeyDownEnd}
            label="до"
            id="outlined-start-adornment"
            sx={{ m: 1, width: '15ch', backgroundColor: "#ffffff" }}
            InputProps={{
              startAdornment: <InputAdornment position="start"></InputAdornment>,
            }}
          />
        </Stack >
      </Box>

      <Box sx={{ width: '90%',ml: 3 }} onMouseLeave={closeSlide}>
        <AirbnbSlider sx={{ mt: 2 }}
          valueLabelDisplay="auto"
          components={{ Thumb: AirbnbThumbComponent }}
          onChange={handleChange}
          value={[valuemin,valuemax]}
          min={minValuePrice}
          max={maxValuePrice}
          onTouchEnd={showMouseUp}
          step={10}
          disableSwap={false}
        />
      </Box>
    </>
  )
};

export default DisplayTypeCompanentPriceMoby;